import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AreaChart, Area, LineChart, Line, PieChart, Pie, Cell, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Switch, IconButton, Select, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';

const AIRoiBusinessImpact = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title">
                <h1>AI ROI & Business Impact Dashboard</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI ROI & Business Impact Dashboard
                </p>
            </div>

            <div className="stats_boxes gap_m mb_20">
                {/* CARD 1 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            AED 922,300
                            <p>AI - Attributed Revenue</p>
                        </h2>
                        <figure className="active_order">
                            <CurrencyExchangeIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>▲ 40%</span>
                        <TrendingUpIcon sx={{ fontSize: 16, color: '#2E7D32', ml: 1 }} />
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            AI - Related
                            <p>ROI is 28%</p>
                        </h2>
                        <figure className="sucess">
                            <TrendingUpIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>▲ Trending Up</span>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            19.6%
                            <p>AI usage rate</p>
                        </h2>
                        <figure className="warning">
                            <QueryStatsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <span style={{ color: '#8B6B4C' }}>▲ 0% (0 last month)</span>
                    </div>
                </div>

                {/* CARD 4 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            15 hours/week
                            <p>Time Saved</p>
                        </h2>
                        <figure className="info">
                            <AccessTimeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>▲ 42% (7s last month)</span>
                    </div>
                </div>

                {/* CARD 5 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            15 hours/week
                            <p>Manual effort reduced</p>
                        </h2>
                        <figure className="purple" style={{ backgroundColor: "#9B87EA" }}>
                            <SettingsSuggestOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <span>▲ 42% (+3 last month)</span>
                    </div>
                </div>
            </div>

            <div className="table_flex">
                <div className="lt">
                    {/* LEFT COLUMN */}
                    <div className="cards table_card mb_20">
                        <div className="cards_header">
                            <div className="left_s">
                                <h2>AI ROI Summary</h2>
                            </div>
                        </div>

                        <div style={{ display: 'flex', borderTop: '1px solid #f0f0f0', marginTop: '15px' }}>
                            {/* BLOCK 1 */}
                            <div style={{ flex: '1 1 35%', padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRight: '1px solid #f0f0f0' }}>
                                <div>
                                    <h3 style={{ fontSize: '24px', margin: '0 0 5px', color: '#333' }}>AED 922,300</h3>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px' }}>
                                        <span style={{ fontSize: '11px', color: '#666' }}>AI-Attributed Revenue</span>
                                        <div style={{ width: '60px', height: '15px' }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <AreaChart data={[{ v: 10 }, { v: 12 }, { v: 11 }, { v: 15 }, { v: 20 }]}>
                                                    <defs>
                                                        <linearGradient id="colorRevSmall" x1="0" y1="0" x2="0" y2="1">
                                                            <stop offset="5%" stopColor="#D84315" stopOpacity={0.3} />
                                                            <stop offset="95%" stopColor="#D84315" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>
                                                    <Area type="monotone" dataKey="v" stroke="#D84315" strokeWidth={2} fillOpacity={1} fill="url(#colorRevSmall)" dot={{ r: 1.5, fill: '#D84315' }} />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px' }}>
                                        <WorkOutlineIcon sx={{ fontSize: 16, color: '#D3B88C' }} />
                                        <span style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>48.2% <span style={{ fontWeight: 400, color: '#666' }}>(60%)</span></span>
                                        <span style={{ fontSize: '10px', color: '#999' }}>This vs prev month</span>
                                    </div>
                                </div>

                                <div>
                                    <Button size="small" variant="text" sx={{ color: '#8B6B4C', textTransform: 'none', padding: 0, minWidth: 'auto', '&:hover': { background: 'transparent' } }}>
                                        <InsertDriveFileOutlinedIcon sx={{ fontSize: 16, mr: 0.5 }} /> Export ROI Report
                                    </Button>
                                </div>
                            </div>

                            {/* BLOCK 2 */}
                            <div style={{ flex: '1 1 30%', padding: '20px', backgroundColor: '#FFFDF9', borderRight: '1px solid #f0f0f0' }}>
                                <h3 style={{ fontSize: '20px', margin: '0 0 5px', color: '#333' }}>AED 158,400</h3>
                                <div style={{ fontSize: '11px', color: '#666', marginBottom: '15px' }}>
                                    AI-related costs (<span style={{ color: '#2E7D32', fontWeight: 600 }}>17.2%</span>)
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <PeopleOutlineIcon sx={{ fontSize: 16, color: '#D3B88C' }} />
                                    <span style={{ fontSize: '12px', color: '#333' }}><b>318</b> Vendor onboarding</span>
                                </div>
                            </div>

                            {/* BLOCK 3 */}
                            <div style={{ flex: '1 1 35%', position: 'relative', display: 'flex', flexDirection: 'column', backgroundColor: '#F6FCF7' }}>
                                <div style={{ padding: '20px 20px 0', position: 'relative', zIndex: 1 }}>
                                    <h3 style={{ fontSize: '22px', margin: '0 0 5px', color: '#333' }}>AED 763,900</h3>
                                    <div style={{ fontSize: '12px', color: '#888' }}>
                                        ROI <span style={{ color: '#2E7D32', fontWeight: 600, fontSize: '11px' }}>▲ 12%</span>
                                    </div>
                                </div>
                                <div style={{ flexGrow: 1, minHeight: '80px', marginTop: '-15px' }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <AreaChart data={[
                                            { name: 'Feb', value: 100 },
                                            { name: 'Mar', value: 250 },
                                            { name: 'Apr', value: 450 },
                                            { name: 'May', value: 800 }
                                        ]}>
                                            <defs>
                                                <linearGradient id="colorRoiLarge" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="5%" stopColor="#4caf50" stopOpacity={0.3} />
                                                    <stop offset="95%" stopColor="#4caf50" stopOpacity={0.0} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: '#999' }} dy={5} />
                                            <Tooltip />
                                            <Area type="monotone" dataKey="value" stroke="#4caf50" strokeWidth={2} fillOpacity={1} fill="url(#colorRoiLarge)" dot={{ r: 3, fill: '#4caf50', strokeWidth: 2, stroke: '#fff' }} />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>

                        <div className="cards table_card">
                            <div className="cards_header">
                                <div className="left_s">
                                    <h2>AI Feature Performance</h2>
                                </div>
                                <div className="right_s form" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '12px', color: '#666' }}>Compare</span>
                                    <div className="d_flex gap_5">
                                        <Button className="btn btn_grey sm active" sx={{ backgroundColor: '#F0E6D2 !important', color: '#8B6B4C !important' }}>Monthly</Button>
                                        <Button className="btn btn_grey sm">Quarterly</Button>
                                        <Button className="btn btn_grey sm">Yearly</Button>
                                    </div>
                                </div>
                            </div>

                            <Table className="custom_table mt_15">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Feature</TableCell>
                                        <TableCell>Revenue</TableCell>
                                        <TableCell align="center">Conversion Lift</TableCell>
                                        <TableCell align="center">Admin Time Saved</TableCell>
                                        <TableCell align="center">ROI</TableCell>
                                        <TableCell align="right">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[
                                        { feature: 'Smart Pricing', rev: '$624,000', conv: '▲ 90%', time: '▲ 363 h', roi: '482%', roiColor: '#2E7D32', active: true },
                                        { feature: 'Recommendation AI', rev: '$158,400', conv: '▼ 80%', time: '▼ 22 h', roi: '+23%', roiColor: '#2E7D32', active: true },
                                        { feature: 'Segmentation AI', rev: '$154,200', conv: '▲ 75%', time: '▼ 10 h', roi: '+42%', roiColor: '#D84315', active: false },
                                        { feature: 'Campaign Suggestor', rev: '$724,000', conv: '▼ 70%', time: '▼ 15 h', roi: '+23%', roiColor: '#2E7D32', active: true },
                                        { feature: 'Dispute AI', rev: '$672,900', conv: '▲ 65%', time: '▼ 15 h', roi: '-20%', roiColor: '#D84315', active: false }
                                    ].map((row, i) => (
                                        <TableRow key={i}>
                                            <TableCell sx={{ fontWeight: 500 }}>{row.feature}</TableCell>
                                            <TableCell>{row.rev}</TableCell>
                                            <TableCell align="center" sx={{ color: row.conv.includes('▲') ? '#2E7D32' : '#E65100' }}>{row.conv}</TableCell>
                                            <TableCell align="center">
                                                {row.time} <span style={{ fontSize: '10px', backgroundColor: '#E8F5E9', color: '#2E7D32', padding: '2px 6px', borderRadius: '4px', marginLeft: '5px' }}>saved</span>
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: row.roiColor, fontWeight: 600 }}>{row.roi}</TableCell>
                                            <TableCell align="right">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                    <Switch checked={row.active} size="small" color={row.active ? "success" : "default"} />
                                                    <IconButton size="small">
                                                        <MoreVertIcon fontSize="small" />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Button className="btn btn_grey sm">Export ROI Report</Button>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="rt">
                    {/* RIGHT COLUMN */}
                

                    <div className="cards table_card" style={{ padding: '0' }}>
                        <div className="cards_header" style={{ padding: '20px 20px 10px' }}>
                            <div className="left_s">
                                <h2>Cost vs Value Breakdown</h2>
                            </div>
                        </div>

                        <div style={{ display: 'flex', position: 'relative' }}>
                            <div style={{ flex: '1 1 60%', padding: '0 20px 20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', borderBottom: '1px solid #f0f0f0', paddingBottom: '15px', marginBottom: '15px' }}>
                                    <div style={{ borderRight: '1px solid #f0f0f0', paddingRight: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                            <ReceiptLongOutlinedIcon sx={{ fontSize: 16, color: '#666' }} />
                                            <h4 style={{ margin: 0, fontSize: '14px', color: '#333' }}>AED 156,400</h4>
                                        </div>
                                        <p style={{ margin: '0 0 0 24px', fontSize: '11px', color: '#888' }}>License/API usage</p>
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                            <FindInPageOutlinedIcon sx={{ fontSize: 16, color: '#D3B88C' }} />
                                            <h4 style={{ margin: 0, fontSize: '14px', color: '#333' }}>AED 622,000</h4>
                                        </div>
                                        <p style={{ margin: '0 0 0 24px', fontSize: '11px', color: '#888' }}>Actionable Revenue</p>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', borderBottom: '1px solid #f0f0f0', paddingBottom: '15px', marginBottom: '15px' }}>
                                    <div style={{ borderRight: '1px solid #f0f0f0', paddingRight: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                            <ReceiptLongOutlinedIcon sx={{ fontSize: 16, color: '#666' }} />
                                            <h4 style={{ margin: 0, fontSize: '14px', color: '#333' }}>AED 32,000</h4>
                                        </div>
                                        <p style={{ margin: '0 0 0 24px', fontSize: '11px', color: '#888' }}>Model Retraining</p>
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                            <AddReactionOutlinedIcon sx={{ fontSize: 16, color: '#D3B88C' }} />
                                            <h4 style={{ margin: 0, fontSize: '14px', color: '#333' }}>AED 67,400</h4>
                                        </div>
                                        <p style={{ margin: '0 0 0 24px', fontSize: '11px', color: '#888' }}>Advanced Insights</p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <PieChart width={16} height={16}>
                                            <Pie data={[{ value: 1 }]} dataKey="value" innerRadius={4} outerRadius={8} fill="#D3B88C" stroke="none" />
                                        </PieChart>
                                        <span style={{ fontSize: '12px', color: '#666' }}>Feature: Revenue</span>
                                    </div>
                                </div>
                            </div>

                            <div style={{ flex: '1 1 40%', backgroundColor: '#FAF8F5', borderTopLeftRadius: '50px', borderBottomLeftRadius: '50px', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                                <div style={{ width: '120px', height: '120px', position: 'relative' }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart>
                                            <Pie
                                                data={[{ value: 82.8 }, { value: 17.2 }]}
                                                innerRadius={45}
                                                outerRadius={55}
                                                startAngle={90}
                                                endAngle={-270}
                                                dataKey="value"
                                                stroke="none"
                                            >
                                                <Cell fill="#DDA057" />
                                                <Cell fill="#EAE5DA" />
                                            </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
                                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                                        <h3 style={{ margin: 0, fontSize: '22px', color: '#333', fontWeight: 600 }}>482%</h3>
                                        <p style={{ margin: 0, fontSize: '11px', color: '#888' }}>ROI</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{ position: 'absolute', bottom: '15px', right: '15px' }}>
                                <Button size="small" variant="outlined" sx={{ fontSize: '11px', borderColor: '#e0e0e0', color: '#333', textTransform: 'none', backgroundColor: '#fff', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                    Trigger Optimization Review
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       

           
            < div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards table_card">
                        <div className="cards_header" style={{ marginBottom: '15px', padding: '0 0 10px', borderBottom: 'none' }}>
                            <div className="left_s">
                                <h2>ROI Per Persona</h2>
                            </div>
                            <div className="right_s">
                                <IconButton size="small"><KeyboardArrowRightIcon fontSize="small" /></IconButton>
                            </div>
                        </div>
                        
                        <div style={{ backgroundColor: '#FDFCFA', borderRadius: '8px', padding: '15px 20px', display: 'flex', flexDirection: 'column', gap: '15px', border: '1px solid #f0f0f0' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr', alignItems: 'center', borderBottom: '1px solid #f0f0f0', paddingBottom: '15px' }}>
                                <div>
                                    <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>Vendors</h4>
                                    <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>ROI 992.571</p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>624,000</h4>
                                    <p style={{ margin: 0, fontSize: '9px', color: '#999', width: '40px' }}>19A/02/30</p>
                                    <div style={{ width: '40px', height: '20px' }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                            <LineChart data={[{v: 10}, {v: 12}, {v: 11}, {v: 14}, {v: 20}]}>
                                                <Line type="monotone" dataKey="v" stroke="#DDA057" strokeWidth={2} dot={false} />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <span style={{ fontSize: '12px', color: '#DDA057', fontWeight: 600 }}>10%</span>
                                </div>
                                <div style={{ borderLeft: '1px solid #f0f0f0', paddingLeft: '20px' }}>
                                    <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>Customers</h4>
                                    <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>26 A/ 65715</p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-end' }}>
                                    <CurrencyExchangeIcon sx={{ fontSize: 14, color: '#666' }} />
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>67,000</h4>
                                        <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>DATABASE</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr', alignItems: 'center' }}>
                                <div>
                                    <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>Admins</h4>
                                    <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>Campaign actions</p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>272,500</h4>
                                    <p style={{ margin: 0, fontSize: '9px', color: '#999', width: '40px' }}>11q/20/87</p>
                                    <div style={{ width: '40px', height: '20px', backgroundColor: '#FEEBCC', borderRadius: '2px', position: 'relative', overflow: 'hidden' }}>
                                       <div style={{ position: 'absolute', top: '10px', left: 0, right: 0, height: '10px', backgroundColor: '#F3D2A1' }}></div>
                                    </div>
                                    <span style={{ fontSize: '12px', color: '#DDA057', fontWeight: 600 }}>18%</span>
                                </div>
                                <div style={{ borderLeft: '1px solid #f0f0f0', paddingLeft: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ fontSize: '14px' }}>♾️</span>
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '10px', color: '#1976D2', textDecoration: 'underline' }}>AWRBINACE</h4>
                                        <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>Admins</p>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-end' }}>
                                    <SavingsOutlinedIcon sx={{ fontSize: 14, color: '#666' }} />
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '13px', color: '#333' }}>52,400</h4>
                                        <p style={{ margin: 0, fontSize: '9px', color: '#999' }}>4173/05</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '20px', gap: '10px' }}>
                            <Button variant="contained" sx={{ backgroundColor: '#A9865A', color: '#fff', textTransform: 'none', padding: '6px 20px', borderRadius: '4px', '&:hover': { backgroundColor: '#8B6B4C' } }}>
                                Generate Report
                            </Button>
                            <Button variant="outlined" sx={{ minWidth: 'auto', padding: '6px', borderColor: '#e0e0e0', color: '#666' }}>
                                <SettingsOutlinedIcon fontSize="small" />
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="rt">
                    <div className="cards table_card" style={{ height: '100%' }}>
                        <div className="cards_header" style={{ marginBottom: '15px', padding: '0 0 10px', borderBottom: 'none' }}>
                            <div className="left_s">
                                <h2>Optimization Recommendations</h2>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {/* REC 1 */}
                            <div style={{ display: 'flex', alignItems: 'flex-start', padding: '15px 0', borderBottom: '1px solid #f0f0f0' }}>
                                <TrackChangesOutlinedIcon sx={{ fontSize: 18, color: '#DDA057', mt: 0.5, mr: 1.5 }} />
                                <div style={{ flex: 1 }}>
                                    <h4 style={{ margin: '0 0 5px', fontSize: '13px', color: '#333', fontWeight: 500 }}>
                                        Scale Up: Disable Segmentation AI caps to 200M/month <span style={{ fontSize: '12px' }}>🛍️ EulOgDOO</span>
                                    </h4>
                                    <p style={{ margin: 0, fontSize: '10px', color: '#888' }}>Avinius freed from two 435 tools</p>
                                </div>
                            </div>

                            {/* REC 2 */}
                            <div style={{ display: 'flex', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #f0f0f0' }}>
                                <SettingsSuggestOutlinedIcon sx={{ fontSize: 18, color: '#DDA057', mr: 1.5 }} />
                                <div style={{ flex: 1 }}>
                                    <h4 style={{ margin: '0 0 5px', fontSize: '13px', color: '#333', fontWeight: 500 }}>
                                        Disable/ Suspend Campaign Optimization as ROI is 16%
                                    </h4>
                                    <p style={{ margin: 0, fontSize: '10px', color: '#888' }}>polniorlicy unit apert crestet</p>
                                </div>
                                <Button size="small" variant="outlined" sx={{ fontSize: '11px', textTransform: 'none', color: '#333', borderColor: '#e0e0e0' }}>
                                    Disable
                                </Button>
                            </div>

                            {/* REC 3 */}
                            <div style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                                <TrendingUpIcon sx={{ fontSize: 18, color: '#DDA057', mr: 1.5 }} />
                                <div style={{ flex: 1 }}>
                                    <h4 style={{ margin: '0 0 5px', fontSize: '13px', color: '#333', fontWeight: 500 }}>
                                        Persona Upsell: Suggest AI upgrade to top 100 Vendors
                                    </h4>
                                    <p style={{ margin: 0, fontSize: '10px', color: '#888' }}>69 retulo 4 21 ,335 , er ups for 00 days</p>
                                </div>
                                <Button size="small" variant="contained" sx={{ fontSize: '11px', textTransform: 'none', backgroundColor: '#FDF7E2', color: '#A9865A', boxShadow: 'none', border: '1px solid #F3E5C2', '&:hover': { backgroundColor: '#F3E5C2', boxShadow: 'none' } }}>
                                    Start Upsell
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default AIRoiBusinessImpact;
